module.exports = __webpack_public_path__ + "static/media/62.e9d66500.jpg";